import { Navigate } from "react-router-dom";
import CookieService from "../context/cookies";

function ProtectedRoute({
  element,
  redirectTo,
}: {
  element: React.ReactNode;
  redirectTo: string;
}) {
  const jwtToken = CookieService.getCookie("jwtToken");

  if (!jwtToken) {
    return <Navigate to={redirectTo} />;
  }

  return <>{element}</>;
}

/* TODO: have to refactor in a component
   and will convert element to Outlet
*/
function ProtectedAdminRoute({
  element,
  redirectTo,
}: {
  element: React.ReactNode;
  redirectTo: string;
}) {
  const token = CookieService.getCookie("adminToken");

  if (!token) {
    return <Navigate to={redirectTo} />;
  }

  return <>{element}</>;
}

function PublicRoute({
  element,
  redirectTo,
}: {
  element: React.ReactNode;
  redirectTo: string;
}) {
  const jwtToken = CookieService.getCookie("jwtToken");

  // If logged in → block access
  if (jwtToken) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{element}</>;
}

function RoleRoute({
  children,
  allowedRoles,
  redirectTo = "/login",
}: {
  children: React.ReactNode;
  allowedRoles: string[];
  redirectTo?: string;
}) {
  const role = CookieService.getCookie("role");

  if (!role || !allowedRoles.includes(role)) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}

export { ProtectedRoute, ProtectedAdminRoute, RoleRoute, PublicRoute };
